import WhiteConfirmationContainer from './WhiteConfirmationContainer';

export default WhiteConfirmationContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/components/WhiteConfirmation/index.js